(function () {
  'use strict';

  /* @ngdoc object
   * @name todo
   * @description
   *
   */
  angular
    .module('vctodo', [
    ]);
}());
